/**
 * Priority order for the document composer "popular" models picker.
 * Intersected with `appSettings.aiAssistEditChatModels` so every option is server-allowed.
 */
export const DOCUMENT_COMPOSER_POPULAR_MODEL_IDS: readonly string[] = [
  'gpt-4o',
  'gpt-4o-mini',
  'gpt-5.4-mini',
  'gpt-4.1',
  'gpt-5',
];

const popularSet = new Set(DOCUMENT_COMPOSER_POPULAR_MODEL_IDS);

/**
 * Full deployment allowlist for the composer picker and search, with popular models first
 * (in {@link DOCUMENT_COMPOSER_POPULAR_MODEL_IDS} order), then remaining ids in API order.
 */
export function composerModelPickerOptions(
  allowedIds: readonly string[],
  defaultId: string,
): string[] {
  if (allowedIds.length === 0) return [defaultId];
  const allowedSet = new Set(allowedIds);
  const popularFirst = DOCUMENT_COMPOSER_POPULAR_MODEL_IDS.filter((id) =>
    allowedSet.has(id),
  );
  const rest = allowedIds.filter((id) => !popularSet.has(id));
  return [...popularFirst, ...rest];
}

export function resolveInitialSessionModel(
  effectivePreferred: string,
  options: readonly string[],
): string {
  if (options.includes(effectivePreferred)) return effectivePreferred;
  return options[0] ?? effectivePreferred;
}
